import { useEffect } from 'react';

const useMount = (effect) => {
    useEffect(() => {
        effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

export default useMount;